module.exports = __webpack_public_path__ + "static/media/bannerImg.9828e543.png";